import { createContext } from 'react';
import type { Dictionary, Locale } from './dictionary';

/**
 * Dil bağlamı — yalnızca context nesnesi.
 *
 * Sağlayıcı bileşeni (`LocaleProvider.tsx`) ve hook'lar (`useT.ts`) ayrı
 * dosyalarda: bir modül hem bileşen hem bileşen-olmayan değer export ettiğinde
 * React Fast Refresh o modülü sıcak değiştiremez ve her düzenlemede tüm
 * uygulama durumu sıfırlanır (`react-refresh/only-export-components`).
 */
export interface LocaleContextValue {
  locale: Locale;
  /** `Intl` API'lerine verilecek etiket (ör. 'tr-TR'). */
  intlLocale: string;
  t: Dictionary;
  setLocale: (locale: Locale) => void;
}

export const LocaleContext = createContext<LocaleContextValue | null>(null);

export const LOCALE_STORAGE_KEY = 'zee.locale';
